export const holidayDateData = {
  title: 'What were the departure and return dates of your booking?',
  image: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/aea862695be0-tooliconcalendar.jpg',
  },
}
